import { Grid } from "@mui/material";
import { transformToAddressMeta } from "./transformer";
import BookPaper from "./book-paper";
import { useEffect, useState } from "react";
import { chunk } from "lodash";

const ITEMS_PER_PAGE = 16;

const AddressBook = ({ dataset }) => {
  const [pageMeta, setPageMeta] = useState([]);

  useEffect(() => {
    try {
      const addressMetaObjs = dataset.map((element) =>
        transformToAddressMeta({ data: element })
      );
      const addressMetaChunks = chunk(addressMetaObjs, ITEMS_PER_PAGE);
      const tempPageMeta = [];
      addressMetaChunks.forEach((addressItems, index) => {
        tempPageMeta.push({
          items: addressItems,
          pageIndex: index,
        });
      });
      setPageMeta(tempPageMeta);
    } catch (error) {
      console.error(error);
    }
  }, [dataset]);

  return (
    <Grid container direction="row">
      {Array.isArray(pageMeta) &&
        pageMeta.map((meta) => (
          <BookPaper key={meta.pageIndex} items={meta.items} meta={meta} />
        ))}
    </Grid>
  );
};

export default AddressBook;
